import { STORE_PUBLISH_FIELD_DETAILS_2 } from '../actions/storePublishFieldDetails2Actions';

interface PublishFields {
    region: string,
    product_id: string,
    product_description: string,
    pricing: number,
    country:string,
    province:string,
    origin: string,
    specification: string
}


export let getPublishFieldDetail2Selector  =  (state: PublishFields) => {
    return state[STORE_PUBLISH_FIELD_DETAILS_2];
  };
  